import { render, staticRenderFns } from "./PricingFaq.vue?vue&type=template&id=04758c0a&scoped=true&"
import script from "./PricingFaq.vue?vue&type=script&lang=js&"
export * from "./PricingFaq.vue?vue&type=script&lang=js&"
import style0 from "./PricingFaq.vue?vue&type=style&index=0&id=04758c0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04758c0a",
  null
  
)

export default component.exports